import { Api } from '@cems-eco/core/src/services/api/api.service';
import { api, apiNet } from '@cems-eco/core/src/services/api';
import { getService } from '@cems-eco/core/src/utils/platform';
import environment from "@/config";
class MonitorApi {
    api: Api;

    constructor() {
        this.api = getService<Api>(environment.nexus, {
            box: api,
            cloud: apiNet,
        });
    }

    async logAll(equipmentId: any): Promise<any> {
        return await this.api.get<any>(`/log/equipment/${equipmentId}`);
    }

    async getEquipment(id: string, params = {}): Promise<any> {
        return await this.api.get<any>(`/equipment/${id}`, params);
    }

    async getEquipments(params = {}): Promise<any> {
        return await this.api.get<any>('/equipment', params);
    }

    searchParams(data: any): any {
        return this.api.toSerialize(data);
    }

    async byEquipment(equipment_id: any): Promise<any> {
        const params = {
            search: {
                advanced: {
                    equipment_id
                }
            },
            "no-paginate": true
        }
        return await this.api.get<any>(`/sensor`, params);
    }

    getUrl(url, params = {}): string {
        return this.api.getUrl(url, params);
    }

    async getCloudSite(id): Promise<any> {
        return await api.get<any>(`/site/${id}`);
    }

}

export default new MonitorApi();
